export const PERMISSION = {
  INITIAL: 'initial',
  BLOCKED: 'blocked',
  PAY_DELAYED: 'pay_delayed',
  PAID: 'paid',
  INVITED_EX: 'invited_ex',
  INVITED_CURRENT: 'invited_current',
};
